import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import { useMdProfileContext } from '../context/useMdProfileContext';
import { DataGridPro } from '@mui/x-data-grid-pro';

export default function MDList() {
  const { mdList, handleViewProfile } = useContext(useMdProfileContext);
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'action',
      headerName: 'Name ',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => (
        <div>
          <Button
            size='small'
            variant='link'
            sx={{ color: '#1565c0' }}
            onClick={() => handleViewProfile(row.md_id, row)}
          >
            {row.name}
          </Button>
        </div>
      ),
    },
    {
      field: 'specialty',
      headerName: 'Specialty',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'primary_clinic',
      headerName: 'Primary Clinic',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'best_day_to_cover',
      headerName: 'Best Day to Cover',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
  ];

  return (
    <div>
      <Typography variant='h6' gutterBottom>
        No. of Doctor(s): {mdList?.data?.length ?? 0}
      </Typography>
      <Box
        className='table-container'
        sx={{
          height: `800px`,
          '& .super-app-theme--header': {
            fontWeight: 'bold',
            backgroundColor: '#6B8D3E',
            color: '#fff',
          },
          // '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#FBCEB1' },
          // '& .even-row': {
          //   backgroundColor: '#c3d1b1' /* Light gray for even rows */,
          // },

          // '& .odd-row': {
          //   backgroundColor: '#f0f3eb' /* White for odd rows */,
          // },
          // '& .MuiDataGrid-row.Mui-hovered': {
          //   backgroundColor: 'inherit',
          // },
          // // Take out the hover colour
          // '& .MuiDataGrid-row:hover': {
          //   backgroundColor: 'inherit',
          // },
        }}
      >
        <DataGridPro
          loading={mdList.loading}
          rows={mdList.data}
          columns={columns}
          sortModel={sortModel}
          initialState={{
            ...mdList.initialState,
            pagination: {
              pageSize: 50,
            },
          }}
          rowsPerPageOptions={[25, 50, 100]}
          pagination
          onSortModelChange={(model) => setSortModel(model)}
          getRowClassName={(params) => {
            return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
          }}
        />
      </Box>
    </div>
  );
}
